module.exports = __webpack_public_path__ + "static/wedding-60ffd99baa63bdba2a7795eef923b559.jpg";